import type { InitOptions } from 'i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import env from '~/configs/env';
import { en, pt } from './locales';

const options: InitOptions = {
  interpolation: {
    escapeValue: false, // not needed for react!!
  },

  debug: env.ENV !== 'production',

  lng: 'pt-BR',

  resources: {
    pt: {
      common: pt['pt-BR'] ?? {},
    },
    en: {
      common: en['en-US'] ?? {},
    },
  },

  fallbackLng: 'en',

  ns: ['common'],

  defaultNS: 'common',

  react: {
    bindI18n: 'languageChanged loaded',
    nsMode: 'default',
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(options)
  .catch((error: Error | unknown): void => console.error('i18n initialization failed:', error));

export default i18n;
